
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '../index';
import TransferInternal from '@/services/TransferInternal';
import { PtiTransferResponseItem } from '@/types/pti';
import { userModule } from '@/store/modules/user';

const PROFESI_DIKUNCI = ['Perawat', 'Bidan'];

let konfigSedangDimuat: Promise<void> | null = null;

@Module({ dynamic: true, namespaced: true, name: 'pti', store })
class PTIModule extends VuexModule {
    triggered = false;

    transfers: PtiTransferResponseItem[] = [];
    loadedRegisterId: number | null = null;
    loadingTransfers = false;

    lockCpptUntilReceived = true;
    configLoaded = false;

    @Mutation
    setTriggered(value: boolean) {
        this.triggered = value;
    }

    @Mutation
    setTransfers(payload: { registerId: number | null; items: PtiTransferResponseItem[] }) {
        this.transfers = payload.items;
        this.loadedRegisterId = payload.registerId;
    }

    @Mutation
    setLoadingTransfers(value: boolean) {
        this.loadingTransfers = value;
    }

    @Mutation
    setLockCpptUntilReceived(value: boolean) {
        this.lockCpptUntilReceived = value;
        this.configLoaded = true;
    }

    @Action
    async fetchConfig() {
        if (this.configLoaded) return;

        if (!konfigSedangDimuat) {
            konfigSedangDimuat = TransferInternal.getConfig()
                .then(cfg => {
                    konfigSedangDimuat = null;
                    this.setLockCpptUntilReceived(cfg?.lock_cppt_until_received !== false);
                })
                .catch(() => {
                    konfigSedangDimuat = null;
                });
        }

        await konfigSedangDimuat;
    }

    @Action
    async fetchByRegister(registerId: number | null) {
        this.fetchConfig();

        if (!registerId) {
            this.setTransfers({ registerId: null, items: [] });
            return;
        }

        this.setLoadingTransfers(true);

        try {
            const res: any = await TransferInternal.getByRegister(registerId);
            const items = Array.isArray(res) ? res : res?.data ?? [];
            this.setTransfers({ registerId, items });
        } catch (e) {
            this.setTransfers({ registerId, items: [] });
        } finally {
            this.setLoadingTransfers(false);
        }
    }

    get pendingIncoming(): PtiTransferResponseItem | null {
        const unitLogin = String(userModule.user?.unit_id ?? '');
        if (!unitLogin) return null;

        const kandidat = this.transfers
            .filter(t => String(t.to_unit_id) === unitLogin && !t.received_at)
            .sort((a, b) =>
                String(b.transfered_at ?? '').localeCompare(String(a.transfered_at ?? ''))
            );

        return kandidat.length ? kandidat[0] : null;
    }

    get cpptLocked(): boolean {
        if (!this.lockCpptUntilReceived) return false;

        if (!PROFESI_DIKUNCI.includes(String(userModule.user?.profesi ?? ''))) {
            return false;
        }

        return !!this.pendingIncoming;
    }

    @Action
    resetFormTransferInternal() {
        this.setTriggered(true);
    }

    @Action
    resetTrigger() {
        this.setTriggered(false);
    }

    get isTriggered() {
        return this.triggered;
    }
}

const ptiStore = getModule(PTIModule);
export default ptiStore;

// create example how to use
/*
import ptiStore from '@/store/modules/pti';

// To trigger the reset
ptiStore.resetFormTransferInternal();
// To reset the trigger after handling
ptiStore.resetTrigger();

//how to use istriggered
if (ptiStore.isTriggered) {
    // handle the reset logic here
    // after handling, reset the trigger
    ptiStore.resetTrigger();
}   
    

*/